<template>
  <div class="flex">
    <div
      class="bg-white drop-shadow-lg rounded-2xl h-min sm:w-screen md:max-w-[550px] border-solid border-1 border-white shadow-[0_2px_4px_0_rgba(0,0,0,0.04)] items-center m-auto"
    >
      <slot />
    </div>
  </div>
</template>
